import * as fetchApi from '@/config/fetchApi.js'
import * as constants from '@/config/constants.js'

export const comparativoCharts = (filter) => fetchApi.post(constants.ENDPOINT_COMPARATIVO_PRODUTOS + '/plots', filter)
export const comparativoCards = (filter) => fetchApi.post(constants.ENDPOINT_COMPARATIVO_PRODUTOS + '/totals', filter)
